import {useEffect, useId, useRef, useState} from 'react'

import {BREAKPOINT} from '../../webgl/_rawConfig'
import type {BrandedDividerParams} from '../WebGLContext/WebGLContext'
import {useWebGLContext} from '../WebGLContext/WebGLContext'

interface WebGLBrandedDividerProps {
  className?: string
  params: BrandedDividerParams
}

export function WebGLBrandedDivider({className, params}: WebGLBrandedDividerProps) {
  const {registerBrandedDivider, unregisterBrandedDivider} = useWebGLContext()
  const ref = useRef<HTMLDivElement>(null)
  const id = useId()
  const [aspectRatio, setAspectRatio] = useState('1600 / 157')

  useEffect(() => {
    if (ref.current) {
      registerBrandedDivider({id, element: ref.current, params})
    }

    const resize = () => {
      if (window.innerWidth <= BREAKPOINT.MOBILE) {
        setAspectRatio(`390 / 115`)
      } else if (window.innerWidth <= BREAKPOINT.TABLET) {
        setAspectRatio(`800 / 131`)
      } else {
        setAspectRatio(`1600 / 157`)
      }
    }

    resize()
    window.addEventListener('resize', resize)

    return () => {
      unregisterBrandedDivider(id)
      window.removeEventListener('resize', resize)
    }
    // Mount-only by design: `id` and the context callbacks are stable, but
    // `params` is an inline object literal at every call site, so a full dep
    // array would unregister/re-register the WebGL layer on every render.
    // Changing `params` after mount is therefore not reflected.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      ref={ref}
      className={className}
      style={{
        width: '100%',
        maxWidth: '1600px',
        aspectRatio,
      }}
    />
  )
}
